module.exports = __webpack_public_path__ + "static/media/google-play-badge.3f8de935.png";